export default {
  // Turned over, a board shows what it is made of: what it means and the
  // numbers behind it (BoardBack). Only a board with a back turns; the
  // presenter's windows and phone turn together, and the next board comes
  // up the right way round.
  backOf(index = this.indexValue) {
    return this.slideTargets[index]?.querySelector(":scope > .deck-back") || null;
  },

  turnOver() {
    this.setTurned(!this.turned, true);
  },

  // From another window: the same board, turned the same way.
  turnTo(data) {
    if (data.slug && data.slug !== this.slugByIndex[this.indexValue]) return;
    this.setTurned(data.turned, false);
  },

  setTurned(on, broadcast) {
    const board = this.slideTargets[this.indexValue];
    if (!board || !this.backOf()) on = false;
    if (on === Boolean(this.turned)) return;
    this.turned = on;
    const swap = () => {
      board.classList.toggle("is-turned", on);
      // Hidden until now, the back is measured and fitted as it shows.
      if (on) board.querySelector(":scope > .deck-back")?.dispatchEvent(new CustomEvent("deck:fit", { bubbles: true }));
      this.renderTurn();
    };
    if (this.calm || this.stacked || this.phoneValue || !board.animate) {
      swap();
    } else {
      // A quarter turn away, the other face swapped in, a quarter turn back.
      const away = board.animate([{ transform: "perspective(2400px) rotateY(0deg)" }, { transform: "perspective(2400px) rotateY(90deg)" }], { duration: 170, easing: "cubic-bezier(0.4, 0, 1, 1)", fill: "forwards" });
      away.finished.then(() => {
        swap();
        away.cancel();
        board.animate([{ transform: "perspective(2400px) rotateY(-90deg)" }, { transform: "perspective(2400px) rotateY(0deg)" }], { duration: 200, easing: "cubic-bezier(0, 0, 0.2, 1)" });
      }, swap);
    }
    if (broadcast) {
      const slug = this.slugByIndex[this.indexValue] || undefined;
      this.channel?.postMessage({ turned: on, slug });
      this.send({ turned: on, slug });
    }
  },

  renderTurn() {
    const has = Boolean(this.backOf());
    this.turnButtonTargets.forEach((button) => {
      button.hidden = !has;
      button.setAttribute("aria-pressed", String(Boolean(this.turned)));
      button.textContent = this.turned ? button.dataset.frontLabel : button.dataset.backLabel;
    });
  },
};
